import axiosRequest from "@/api/axios-optimize"

// 获取服务器详情
export function getServerInfo(
  data = {},
  config = {
    timeout: 30000, // 请求超时时间延长一点
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/monitor/server/getServerInfo`, { params: data, ...config })
}

// 获取在线用户列表
export function getOnlineUserList(
  data = {},
  config = {
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/monitor/online/getOnlineUserList`, { params: data, ...config })
}

// 批量强退用户
export function batchExitUsers(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.delete("/xiaobuAdmin/monitor/online/batchExitUsers", { data, ...config })
}